import { render, staticRenderFns } from "./InvitesContent.vue?vue&type=template&id=9fd199ee"
import script from "./InvitesContent.vue?vue&type=script&lang=js"
export * from "./InvitesContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports